var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        staticClass: "modal",
        class: _vm.value ? "show" : "hide",
        style: _vm.value
          ? "display:block;background-color:#3333337a;"
          : "display:none;",
        attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-dialog modal-dialog-centered modal-dialog-scrollable",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticClass: "modal-header d-flex flex-row align-items-center"
                },
                [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Demande de résiliation")
                  ])
                ]
              ),
              _c("div", { staticClass: "modal-body" }, [
                _vm.reqError
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center full-available-height"
                      },
                      [_vm._v(" " + _vm._s(_vm.reqError) + " ")]
                    )
                  : _c(
                      "div",
                      [
                        _vm.value
                          ? _c("flow-form", {
                              ref: "flowform",
                              attrs: {
                                questions: _vm.questions,
                                language: _vm.language,
                                navigation: true
                              },
                              on: { submit: _vm.submitCancellationRequest }
                            })
                          : _vm._e()
                      ],
                      1
                    )
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.closeModal }
                  },
                  [_vm._v(" Fermer ")]
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }